import { useTranslation } from "react-i18next"

const NotFound = () => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-6">
      <h1 className="text-9xl font-bold text-gray-800 animate-bounce">404</h1>
      <p className="text-2xl mt-4 text-gray-700">{t("notFound.title")}</p>
      <p className="text-center text-gray-500 mt-2 max-w-md">
        {t("notFound.description")}
      </p>
      <a
        href="/auth/signin"
        className="mt-6 inline-block bg-[#00c853] text-white px-6 py-3 rounded-xl text-lg font-medium hover:bg-[#00b24d] transition"
      >
        {t("notFound.goBack")}
      </a>
    </div>
  )
}

export default NotFound
